import React, { useState, useEffect, useMemo } from "react";
import { SubAdminsellrecordApi } from "../../CommonAPI/SubAdmin";
import "react-datepicker/dist/react-datepicker.css";
import NoDataFound from "../../../ExtraComponent/NoDataFound";
import Content from "../../../ExtraComponent/Content";

const Clientactivity = () => {
  const Username = sessionStorage.getItem("Username");

  /** ---------- Default Dates ---------- **/
  const today = new Date();
  const formatDate = (date) => date.toISOString().split("T")[0];
  const defaultToDate = formatDate(today);

  const fromDate = new Date();
  fromDate.setMonth(fromDate.getMonth() - 1);
  const defaultFromDate = formatDate(fromDate);

  /** ---------- States ---------- **/
  const [toDate, setToDate] = useState(defaultToDate);
  const [fromDateState, setFromDateState] = useState(defaultFromDate);
  const [clientActivity, setClientActivity] = useState({
    loading: true,
    data: [],
  });
  const [searchTerm, setSearchTerm] = useState("");

  /** ---------- Fetch Client Activity ---------- **/
  const fetchClientActivity = async () => {
    try {
      const response = await SubAdminsellrecordApi();
      if (response?.Status) {
        setClientActivity({ loading: false, data: response.Data });
      } else {
        setClientActivity({ loading: false, data: [] });
      }
    } catch (err) {
      console.error("Error fetching client details:", err);
      setClientActivity({ loading: false, data: [] });
    }
  };

  useEffect(() => {
    fetchClientActivity();
  }, [toDate, fromDateState]);

  /** ---------- Filtered Data by Search ---------- **/
  const filteredData = useMemo(() => {
    if (!searchTerm.trim()) return clientActivity.data;
    return clientActivity.data.filter((item) =>
      Object.values(item)
        .join(" ")
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
    );
  }, [searchTerm, clientActivity.data]);

  /** ---------- Render ---------- **/
  return (
    <Content
      Page_title={"📉 Client Activity"}
      button_status={false}
      backbutton_status={true}
    >  <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
        <li className="breadcrumb-item active " aria-current="page">
          Transaction History
        </li>
      </ol>
    </nav>

      {/* Page Body */}
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "10px",
          padding: "20px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        }}
      >
        {/* Search */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <input
            type="text"
            placeholder="🔍 Search client activity..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              width: "280px",
              padding: "10px 14px",
              border: "1px solid #ccc",
              borderRadius: "8px",
              fontSize: "0.95rem",
              outline: "none",
            }}
          />
        </div>

        {/* Table Section */}
        <div style={{ overflowX: "auto" }}>
          {clientActivity.loading ? (
            <div
              style={{
                textAlign: "center",
                padding: "20px",
                color: "#888",
                fontSize: "1rem",
              }}
            >
              Loading...
            </div>
          ) : filteredData.length > 0 ? (
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                border: "1px solid #e0e0e0",
              }}
            >
              <thead
                style={{
                  backgroundColor: "#f5f7fa",
                  textAlign: "left",
                }}
              >
                <tr>
                  <th
                    style={{
                      padding: "12px",
                      borderBottom: "1px solid #ddd",
                      width: "80px",
                      textAlign: "center",
                    }}
                  >
                    S.No
                  </th>
                  <th
                    style={{
                      padding: "12px",
                      borderBottom: "1px solid #ddd",
                      minWidth: "160px",
                    }}
                  >
                    Username
                  </th>
                  <th
                    style={{
                      padding: "12px",
                      borderBottom: "1px solid #ddd",
                      minWidth: "200px",
                    }}
                  >
                    Plan Name
                  </th>
                  <th
                    style={{
                      padding: "12px",
                      borderBottom: "1px solid #ddd",
                      minWidth: "150px",
                      textAlign: "center",
                    }}
                  >
                    Credit Used
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((item, index) => (
                  <tr
                    key={index}
                    style={{
                      borderBottom: "1px solid #eee",
                      backgroundColor: index % 2 === 0 ? "#fff" : "#fafafa",
                    }}
                  >
                    <td style={{ padding: "10px", textAlign: "center" }}>
                      {index + 1}
                    </td>
                    <td style={{ padding: "10px", color: "#333" }}>
                      {item.Username || "-"}
                    </td>
                    <td style={{ padding: "10px", color: "#333" }}>
                      {item.Planname?.length ? item.Planname : "-"}
                    </td>
                    <td
                      style={{
                        padding: "10px",
                        color: "#007bff",
                        fontWeight: "500",
                        textAlign: "center",
                      }}
                    >
                      {item.Subadminamount || "0"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <NoDataFound />
          )}
        </div>
      </div>
    </Content>
  );
};

export default Clientactivity;
